import * as React from 'react'

interface ITimeInputProps {
  className: string;
  time: number;
  onChange: (newValue: number | string) => void;
  onFocus?: (event: React.FocusEvent) => void;
  onBlur?: (event: React.FocusEvent) => void;
}

interface ITimeInputState {
  cleared: boolean;
}

class TimeInput extends React.Component<ITimeInputProps, ITimeInputState> {
  public constructor(props: ITimeInputProps) {
    super(props);

    this.state = {
      cleared: false
    };
  }

  public render() {
    return (
      <input
        className={this.props.className}
        type="number"

        value={this.getValue()}

        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        />
    );
  }

  private getValue = () : string => {
    return this.state.cleared ? '' : this.props.time.toString();
  };

  private onBlur = (event: React.FocusEvent) : void => {
    this.setState({ cleared: false });

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  private onFocus = (event: React.FocusEvent) => {
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  };

  private onKeyDown = (event: React.KeyboardEvent) : void => {
    if (event.key === "Enter") {
      const element = event.target as HTMLInputElement;
      element.blur();
      this.setState({ cleared: false });
      event.preventDefault();
    }
  };

  private onChange = (event: React.ChangeEvent) : void => {
    const element = event.target as HTMLInputElement
    if (element.value === '') {
      this.setState({ cleared: true });
      this.props.onChange(0);
      return;
    }

    this.setState({ cleared: false });
    this.props.onChange(element.value);
  };
}

export default TimeInput;



// WEBPACK FOOTER //
// ./src/App/Elements/TimeInput.tsx